export default "__VITE_ASSET__c2593200__"